import Layout from "@/views/layout";

const comboRouter = {
  path: "/combo",
  name: "Combo",
  component: Layout,
  meta: { title: "套餐模块" },
  children: [
    {
      path: "membersPackage",
      name: "MembersPackage",
      component: () => import("@/views/combo/membersPackage"),
      meta: { title: "发布套餐" }
    },
    {
      path: "membersPackageList",
      name: "MembersPackageList",
      component: () => import("@/views/combo/membersPackageList"),
      meta: { title: "套餐列表" }
    },
    {
      path: "editMembersPackage",
      name: "EditMembersPackage",
      component: () => import("@/views/combo/editMembersPackage"),
      meta: { title: "套餐修改" }
    },
    {
      path: "comboList",
      name: "ComboList",
      component: () => import("@/views/combo/comboList"),
      meta: { title: "购买套餐" }
    },
    {
      path: "comboDetail",
      name: "ComboDetail",
      component: () => import("@/views/combo/comboDetail"),
      meta: { title: "套餐详情" }
    }
  ]
};

export default comboRouter;
